import * as Sentry from '@sentry/react';
import type { AxiosRequestConfig } from 'axios';

// These represent the standard error format of our Rails backend.
export interface ServerError {
  title: string;
  details?: string | object;
  /**
   * Optional ID for a particular error.
   */
  code?: string;
  source?: {
    pointer: string;
  };
}

export default class ApiResponseError extends Error {
  public name = 'ApiResponseError';
  public message: string;
  public errors?: ServerError[];

  // For reporting
  public code: string | undefined;
  public method: AxiosRequestConfig['method'];
  public status: number;
  public uri: string;

  constructor({
    code,
    errors,
    message,
    method,
    status,
    uri,
  }: {
    code?: string | undefined;
    errors?: ServerError[];
    message?: string;
    method: AxiosRequestConfig['method'];
    status: number;
    uri: string;
  }) {
    message ??= [code, status, method, uri].filter(Boolean).join(' ');

    Sentry.setExtras({
      code,
      errors,
      method,
      status,
      uri,
    });

    // See https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);

    this.code = code;
    this.errors = errors;
    this.message = message;
    this.method = method;
    this.status = status;
    this.uri = uri;
  }
}
